export default container => {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const { target } = entry
        const animateElements = target.querySelectorAll(
          '[data-animate-element]'
        )

        if (entry.isIntersecting) {
          animateElements.forEach(el => el.classList.add('animate__scale-up'))

          observer.unobserve(target)
        }
      })
    },
    {
      rootMargin: '-100px 0px',
    }
  )

  container
    .querySelectorAll('[data-animation-container]')
    .forEach(section => observer.observe(section))
}
